import request from '@/utils/response'

export function registerInfo(data) {
    return request({
        url: '/user/register_info',
        method: 'post',
        data
    })
}
